module.exports = __webpack_public_path__ + "static/media/TropicalParadise.1928058c.jpg";